import type { KeyDate } from '../types';
import { getDaySuffix } from './get-day-suffix';

export const formatKeyDate = (keyDate: KeyDate): string => {
  if (!keyDate.startDate) {
    return keyDate.month;
  }

  const startDate = new Date(keyDate.startDate);
  const startDay = getDaySuffix(startDate.getDate());
  const startMonth = startDate.toLocaleString('en-US', { month: 'short' });

  if (keyDate.endDate) {
    const endDate = new Date(keyDate.endDate);
    const endDay = getDaySuffix(endDate.getDate());
    const endMonth = endDate.toLocaleString('en-US', { month: 'short' });

    return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
  }

  return `${startMonth} ${startDay}`;
};

export const formatKeyDateBadge = (keyDate: KeyDate): string => {
  if (!keyDate.startDate) {
    return keyDate.month;
  }

  const startDate = new Date(keyDate.startDate);
  const day = getDaySuffix(startDate.getDate());
  const month = startDate.toLocaleString('en-US', { month: 'long' });

  return `${day} ${month}`;
};

export const formatKeyDateBadgeSplit = (keyDate: KeyDate): { date: string } => {
  if (!keyDate.startDate) {
    return { date: '' };
  }

  const startDate = keyDate.startDate;
  const endDate = keyDate.endDate;
  const day = getDaySuffix(new Date(startDate).getDate());
  const month = new Date(startDate).toLocaleString('en-US', { month: 'long' });
  const year = new Date(startDate).getFullYear();
  const isTheSameMonth = endDate ? new Date(startDate).getMonth() === new Date(endDate).getMonth() : false;

  if (endDate) {
    const endDay = getDaySuffix(new Date(endDate).getDate());
    const endMonth = new Date(endDate).toLocaleString('en-US', { month: 'long' });
    const endYear = new Date(endDate).getFullYear();
    const date = isTheSameMonth
      ? `${day} - ${endDay} ${month} ${year}`
      : `${day} ${month} - ${endDay} ${endMonth} ${endYear}`;
    return { date };
  }

  return { date: `${day} ${month} ${year}` };
};
